import React from 'react'


export default function ProductMobile(){
    return(
        <>
            <div style={{paddingTop:30 ,paddingBottom:100,backgroundColor:'white'}}>
                <div style={{display: 'flex',
                    flexDirection: "column",
                    alignItems: "center",}}>
                <img alt="No Images" src="images/doorbell_hard.png"
                     style={{
                         width:350,paddingBottom:20
                     }}/>
                    <img alt="No Images" src="images/doorbell_text.png"
                         style={{
                             width:200,paddingBottom:20
                         }}/>
                    <img alt="No Images" src="images/doorbell_point.png"
                         style={{
                             width:350
                         }}/>
                </div>
            </div>
        </>
    )
}